import React from 'react';
import Axios from 'axios';
import Context from './Context';
import { useDidMount } from '../../use';
import { asserts } from '../../../utils';

const checkVersion = async (targetVersion) => {
  // 加一下 try catch 防止自爆
  try {
    const response = await Axios.get(`${process.env.TARGET}version.js?_t=${new Date().getTime()}`, {
      withCredentials: true,
      headers: { Accept: 'text/html' },
    });
    // 不存在返回值的时候，说明可能出了问题，会导致一直触发diff刷新
    if (!asserts.isExist(response.data)) return;
    const serveVersion = `${response.data}`.trim();
    // console.warn('[target version ]: ', serveVersion);
    // console.warn('[serve version ]: ', serveVersion);
    // console.warn('[is diff]:', targetVersion !== serveVersion);
    if (targetVersion !== serveVersion) {
      window.location.reload();
    }
  } catch (error) {
    // 出错的情况就不要做diff判断了
    console.error('[version error]', error);
  }
};

const VersionChecker = () => {
  const { history } = React.useContext(Context);

  useDidMount(() => {
    const targetVersion = document.getElementsByTagName('html')[0].version;
    // console.warn('[html target version]: ', targetVersion);

    const unlisten = history.listen(() => {
      checkVersion(`${targetVersion}`.trim());
    });
    return () => {
      unlisten();
    };
  });

  return null;
};

export default VersionChecker;
